import * as THREE from "three";
import { assignV3, toRad } from "../../../../utils/spatial";
import { RobotPhysXActor } from "../RobotPhysXActor";
import { ScanCfg, SimScan } from "../../../../models/Robot";
import { RTPhysXSimSensor } from "./RTPhysXSensor";

export class SimLidar extends RTPhysXSimSensor {
  private interval = 1000;
  private nextScan = Date.now();
  private angleStep = 0;
  public fanData: number[] = [];
  private raycaster = new THREE.Raycaster();
  // private channel: LidarChannel;
  private marker = new THREE.Group();
  private startAngle: number;
  private endAngle: number;
  private verticalScan = {
    stepSize: 0,
    ringsDown: 0,
    ringsUp: 0,
  };
  ringAngles: number[];
  constructor(actor: RobotPhysXActor,
    public parent: THREE.Object3D,
    public simCfg: SimScan,
    public scanCfg: ScanCfg,
  ) {

    super(actor);
    assignV3(this.marker.position, scanCfg.position);
    // this.channel = this.actor.robocoreClient.getChannel('lidar') as LidarChannel;
    this.interval = 1000.0 / (this.simCfg.frequency || 1.0);
    this.startAngle = toRad(this.simCfg.arc.min || 30.0);
    this.endAngle = toRad(this.simCfg.arc.max || 30.0);
    this.angleStep = (this.endAngle - this.startAngle) / (this.simCfg.rays || 10);
    this.raycaster.far = this.simCfg.range.max || 8.0;
    this.parent.add(this.marker);
    this.marker.visible = false;
    if (this.simCfg.verticalScan) {
      Object.assign(this.verticalScan, this.simCfg.verticalScan);
    }
    this.ringAngles = [0];
    for (let ring = 1; ring <= this.verticalScan.ringsUp; ring++) {
      this.ringAngles.push(toRad(ring * this.verticalScan.stepSize));
    }
    for (let ring = 1; ring <= this.verticalScan.ringsDown; ring++) {
      this.ringAngles.push(-toRad(ring * this.verticalScan.stepSize));
    }

    this.isOn = true;
  }

  public async activate() {
    await super.activate();
  }

  public async deactivate() {
    await super.deactivate();
    // this.parent.remove(this.marker);
  }

  public collectAndSendData(delta: number) {
    // return;
    if (!this.isOn || this.nextScan > Date.now()) {
      return;
    }
    const start = Date.now();
    const origin = new THREE.Vector3();
    this.marker.getWorldPosition(origin);
    // console.log("SimScanSensor origin: ", origin);
    const scan3dData: number[] = [];
    const scan2dData: number[] =
      [
        this.startAngle,
        this.endAngle,
        this.angleStep,
        this.simCfg.range.min,
        this.simCfg.range.max
      ];
    const worldQuat = this.marker.getWorldQuaternion(new THREE.Quaternion());
    for (let ringAngleIndex = 0; ringAngleIndex < this.ringAngles.length; ringAngleIndex++) {
      const ringAngle = this.ringAngles[ringAngleIndex];
      // console.log("SimScanSensor ringAngle: ", ringAngle);
      for (let angle = this.startAngle; angle < this.endAngle; angle += this.angleStep) {
        const unit = new THREE.Vector3(
          Math.cos(angle),
          Math.sin(angle),
          Math.sin(ringAngle)
        );
        unit.applyQuaternion(worldQuat);
        unit.normalize();
        this.raycaster.set(origin, unit);
        const scannableObjects = this.actor.scene.scene.children;
        // console.log('scannable count: ', scannableObjects.length);
        const intersections = this.raycaster.intersectObjects(scannableObjects, true);
        // console.log("SimScanSensor: ", angle, intersections[0]?.distance);
        // if (ringAngle < -0.5) {
        //   console.log({ unit, intersections, scannableObjects });
        //   debugger;
        // }
        if (intersections.length > 0 &&
          intersections[0].distance < this.simCfg.range.max &&
          intersections[0].distance > this.simCfg.range.min) {
          if (ringAngleIndex === 0) {
            scan2dData.push(intersections[0].distance);
          }
          let point = new THREE.Vector3().copy(intersections[0].point);
          point = this.marker.worldToLocal(point);
          scan3dData.push(point.x, point.y, point.z);
        } else if (ringAngleIndex === 0) {
          scan2dData.push(Number.POSITIVE_INFINITY);
        }
      }
      if (ringAngleIndex === 0) {
        this.sendUIData('lidar2d', scan2dData);
      }
    }
    if (this.ringAngles.length > 1) {
      // console.log("SimScanSensor 3D points: ", scan3dData);
      this.sendUIData('lidar3d', scan3dData);
    }
    // console.log("SimScanSensor: ", data);
    // this.channel.send(data);
    // console.log("SimScanSensor took: ", Date.now() - start);
    this.nextScan = Date.now() + this.interval;
  }

  public friendlyName(): string {
    return 'Sim Lidar';
  }

  public getId(): string {
    return 'SimLidarSensor';
  }
}